<template>
  <Tabs
    :value="modelValue"
    :unstyled="true"
    :pt="passThrough"
    class="meridia-tabs"
    v-bind="$attrs"
    @update:value="onValueUpdate"
  >
    <slot />
  </Tabs>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue';
import Tabs from 'primevue/tabs';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import type { TabsPassThroughOptions } from 'primevue/tabs';
import { MERIDIA_TABS_ACTIVE_VALUE } from 'src/design_system/components/tab/types';
import type { MeridiaTabsProps } from 'src/design_system/components/tab/types';
import { useTabTransition } from 'src/design_system/components/tab/useTabTransition';

const modelValue = defineModel<string | number>({ required: true });

provide(MERIDIA_TABS_ACTIVE_VALUE, modelValue);
useTabTransition(modelValue);

const props = defineProps<MeridiaTabsProps>();

defineSlots<{ default: () => any }>();

const emit = defineEmits<{
  (e: 'update:value', value: string | number): void;
}>();

function onValueUpdate(value: string | number) {
  modelValue.value = value;
  emit('update:value', value);
}

const passThrough = computed(() =>
  usePassThrough(
    props.pt,
    {
      root: {
        class: 'meridia-tabs-root rounded-none font-bold w-full flex-1 min-h-0 flex flex-col',
      },
    } as TabsPassThroughOptions,
    { mergeSections: false, mergeProps: true }
  ) as PassThrough<TabsPassThroughOptions>
);
</script>
